import React from 'react';
import { InputCheckBoxStyle } from './style';

export default function InputCheckBox({ title, id }) {
  return (
    <InputCheckBoxStyle>
      <input type="checkbox" name={id} id={id} />
      <label htmlFor={id}>{title}</label>
    </InputCheckBoxStyle>
  );
}
